module.exports = __webpack_public_path__ + "static/media/sup_sit_spe_met.1565f12e.png";